import React, { useEffect, useState } from "react";
import { Card, Col, Container, Form, Row, TextArea } from "react-bootstrap";
import logoCenec from "../assets/cenec_2.svg";
import logoChorotega from "../assets/chorotega_2.svg";
import state from "../utils/departamentos.json";
import town from "../utils/municipios.json";
import { useFormContext } from "react-hook-form";
import { GENDER_OPTIONS } from "../utils/constants";
import ReactInputMask from 'react-input-mask';

export const SlideOne = ( formData ) => {
  const { register, setValue, getValues, formState: { errors } } = useFormContext();

  const [selectedState, setSelectedState] = useState("");
  const [selectedTown, setSelectedTown] = useState("");
  const [documentType, setDocumentType] = useState("");
  const [stateName, setStateName] = useState("");
  const [townName, setTownName] = useState("");

  useEffect(() => {
    const stateCode = getValues("state_code");
    const townCode = getValues("town_code");
    const docType = getValues("document_type"); 

    if (stateCode) {
      setSelectedState(stateCode);
    }
    if (townCode) {
      setSelectedTown(townCode);
    }
    if (docType) { 
      setDocumentType(docType);
    }
  }, []);

  const handleStateChange = (e) => {
    const code = e.target.value;
    setSelectedState(code);

    const states = state.state.find((dept) => dept.state_code === code);
    if (states) {
      setStateName(states.state_name);
      setValue("state_name", states.state_name);
      setValue("regions", states.regions);
    }

    setSelectedTown("");
    setValue("town_code", ""); 
    setValue("town_name", "");
  };

  const handleTownChange = (e) => {
    const code = e.target.value;

    const towns = town.town.find((town) => town.town_code === code);
    if (towns) {
      setTownName(towns.town_name);
      setValue("town_name", towns.town_name);
    }
  };

  const handleDocumentChange = (e) => {
    const docType = e.target.value;
    setDocumentType(docType);
    setValue("document_type", docType, { shouldValidate: true });
    setValue("identity", ""); 
  };

  const filteredTowns = town.town.filter((town) =>
    town.town_code.startsWith(selectedState)
  );

  const identityMask =
    documentType === "DNI"
      ? "9999-9999-99999"
      : documentType === "Residencia"
      ? "99-9999-9999-99999"
      : "";


  return (
    <Container className="" style={{ maxWidth: "1200px" }}>
      <div className="d-flex justify-content-center mb-3 ms-2 me-2">
        <Card className="card-custom-style">
          <Card.Header className="white-bg-color">
            {/* ... (Todo el header de la card sigue igual) ... */}
            <Row className="justify-content-center">
              <Col md={10}>
                <Row className="justify-content-center cenec-bg-color-v2 mx-1 p-3 rounded-1 mb-3 mt-3">
                  <Col
                    xl={5}
                    md={5}
                    sm={5}
                    xs={12}
                    className="order-last order-sm-first order-md-first"
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      <img
                        src={logoCenec}
                        alt="Logo CENEC"
                        className="img-cenec"
                      />
                    </div>
                  </Col>
                  <Col
                    xl={2}
                    md={2}
                    sm={2}
                    className="d-none d-sm-block text-center"
                  >
                    <div className="vl"></div>
                  </Col>
                  <Col xs={12} className="d-block d-sm-none">
                    <div className="hl"></div>
                  </Col>
                  <Col
                    xl={5}
                    md={5}
                    sm={5}
                    xs={12}
                    className="order-first order-sm-last order-md-last"
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      <img
                        src={logoChorotega}
                        alt="Logo Cooperativa Chorotega"
                        className="img-owner"
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <Form>
              <Row className="justify-content-center">
                <Col md="10" className="mt-3 mb-2">
                  <h2 className="fs-5">
                    Formulario para registro de clientes CENEC
                  </h2>
                </Col>
                <div className="w-100"></div>
                <Col md="10" className="mt-3 mb-2">
                  <h2 className="fs-5">I. Información de contacto</h2>
                </Col>
                <div className="w-100"></div>

                {/* ... (Campos Fullname, Gender, Age siguen igual) ... */}
                <Col md="10" sm="12" xs="12" className=" mb-3">
                  <div className="form-floating">
                    <Form.Control
                      type="text"
                      id="idFullname"
                      placeholder=""
                      {...register("fullname", {
                        required: "Nombre completo es requerido",
                      })}
                    />
                    {errors.fullname && (
                      <p className="text-danger">{errors.fullname.message}</p>
                    )}
                    <label htmlFor="idFullname">Nombre completo</label>
                  </div>
                </Col>

                <Col md="5" sm="12" xs="12" className=" mb-3">
                  <Form.Label>Genero</Form.Label>
                  <div className="d-flex">
                    {GENDER_OPTIONS.map((option) => (
                      <Form.Check
                        key={option.value}
                        type="radio"
                        id={`gender-${option.value}`}
                        label={option.label}
                        value={option.value}
                        name="gender"
                        className="me-3"
                        {...register("gender", {
                          required: "El género es requerido",
                        })}
                      />
                    ))}
                  </div>
                  {errors.gender && (
                    <p className="text-danger">{errors.gender.message}</p>
                  )}
                </Col>
                <Col md="5" sm="12" xs="12" className=" mb-3">
                  <div className="form-floating">
                    <Form.Control
                      type="number"
                      id="idAge"
                      placeholder=""
                      {...register("age", { required: "La edad es requerida" })}
                    />
                    {errors.age && (
                      <p className="text-danger">{errors.age.message}</p>
                    )}
                    <label htmlFor="idAge">Edad</label>
                  </div>
                </Col>


                <Col md="5" sm="6" xs="12" className="mb-3">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      id="selectDocument"
                      aria-label="Selecciona Documento"
                      {...register("document_type", {
                        required: "El tipo de documento es requerido",
                      })}
                      value={documentType}
                      onChange={handleDocumentChange}
                    >
                      <option value="" disabled>
                        Seleccione Documento
                      </option>
                      <option value="DNI">DNI</option>
                      <option value="Residencia">Carnet de Residencia</option>
                    </select>
                    <label htmlFor="selectDocument">Documento</label>
                  </div>
                  {errors.document_type && (
                    <p className="text-danger">{errors.document_type.message}</p>
                  )}
                </Col>

                <Col md="5" sm="12" xs="12" className=" mb-3">
                  <div className="form-floating">
                    <ReactInputMask
                      type="text"
                      id="idIdentity"
                      placeholder=""
                      mask={identityMask}
                      maskChar={" "}
                      className="form-control"
                      disabled={!documentType}
                      {...register("identity", {
                        required: "La identidad es requerida",
                      })}
                    />
                    {errors.identity && (
                      <p className="text-danger">{errors.identity.message}</p>
                    )}
                    <label htmlFor="idIdentity">Identidad</label>
                  </div>
                </Col>

                <Col md="5" sm="12" xs="12" className=" mb-3">
                  <div className="form-floating">
                    <Form.Control
                      type="email"
                      id="idEmail"
                      placeholder=""
                      {...register("email", {
                        required: "El correo electronico es requerida",
                      })}
                    />
                    {errors.email && (
                      <p className="text-danger">{errors.email.message}</p>
                    )}
                    <label htmlFor="idEmail">Correo electronico</label>
                  </div>
                </Col>
                <Col md="5" sm="12" xs="12" className=" mb-3">
                  <div className="form-floating">
                    <Form.Control
                      type="text"
                      id="idAccounting"
                      placeholder=""
                      {...register("accounting", {
                        required: "La cuenta retirable es requerida",
                      })}
                    />
                    {errors.accounting && (
                      <p className="text-danger">{errors.accounting.message}</p>
                    )}
                    <label htmlFor="idAccounting">Número de cuenta retirable Chorotega</label>
                  </div>
                </Col>

                <Col md="5" sm="12" xs="12" className=" mb-3">
                  <div className="form-floating">
                    <ReactInputMask
                      type="text"
                      id="idRtn"
                      placeholder=""
                      mask={"9999-9999-999999"}
                      maskChar={" "}
                      className="form-control"
                      {...register("rtn")}
                    />
                    {errors.rtn && (
                      <p className="text-danger">{errors.rtn.message}</p>
                    )}
                    <label htmlFor="idRtn">RTN</label>
                  </div>
                </Col>

                <Col md="5" sm="6" xs="12" className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">+504</span>
                    <div className="form-floating">
                      <ReactInputMask
                        type="text"
                        id="idPhone"
                        placeholder="Número de telefono"
                        mask={"9999-9999"}
                        maskChar={" "}
                        className="form-control"
                        {...register("phone", {
                          required: "El telefono es requerido",
                        })}
                      />

                      <label htmlFor="idPhone">Número de telefono</label>
                    </div>
                  </div>
                  {errors.phone && (
                    <p className="text-danger">{errors.phone.message}</p>
                  )}
                </Col>

                <Col md="10" sm="12" xs="12" className=" mb-3">
                  <div className="form-floating">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      id="idAddress"
                      placeholder=" "
                      style={{ height: "auto" }}
                      {...register("address", {
                        required: "La dirección es requerida",
                      })}
                    />
                    {errors.address && (
                      <p className="text-danger">{errors.address.message}</p>
                    )}
                    <label htmlFor="idAddress">Dirección vivienda</label>
                  </div>
                </Col>

                <Col md="5" sm="6" xs="12" className="mb-3">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      id="selectStates"
                      aria-label="Selecciona Departamento"
                      {...register("state_code", {
                        required: "El departamento es requerido",
                      })}
                      onChange={handleStateChange}
                    >
                      <option value="">Seleccione Departamento</option>
                      {state.state.map((item) => (
                        <option key={item.state_code} value={item.state_code}>
                          {item.state_name}
                        </option>
                      ))}
                    </select>
                    {errors.state_code && (
                      <p className="text-danger">{errors.state_code.message}</p>
                    )}
                    <label htmlFor="selectStates">Departamento</label>
                  </div>
                  <input type="hidden" {...register("state_name")} />
                  <input type="hidden" {...register("regions")} />
                </Col>

                <Col md="5" sm="12" xs="12" className="mb-3">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      id="selectTowns"
                      aria-label="Selecciona Municipio"
                      {...register("town_code", {
                        required: "El municipio es requerido",
                      })}
                      onChange={handleTownChange}
                      disabled={!selectedState}
                    >
                      <option value="">Seleccione Municipio</option>
                      {filteredTowns.map((item) => (
                        <option key={item.town_code} value={item.town_code}>
                          {item.town_name}
                        </option>
                      ))}
                    </select>
                    {errors.town_code && (
                      <p className="text-danger">{errors.town_code.message}</p>
                    )}
                    <label htmlFor="selectTowns">Municipio</label>
                  </div>
                  <input type="hidden" {...register("town_name")} />
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};